import React, { useEffect, useMemo, useState, useCallback } from "react"
import PropTypes from "prop-types"
import { Link, useLocation, useParams } from "react-router-dom"
import { isEmpty } from "lodash"
import "bootstrap/dist/css/bootstrap.min.css"
import TableContainer from "../../../../components/Common/TableContainer"

//import components
import Breadcrumbs from "../../../../components/Common/Breadcrumb"

import {
  Event_Description,
  Package,
  PaidDate,
  PurchaseAmount,
  PurchaseDate,
  Vendor_name,
} from "./PurchasesListCol"

//redux
import { useSelector, useDispatch } from "react-redux"
import {
  Col,
  Row,
  UncontrolledTooltip,
  Modal,
  ModalHeader,
  ModalBody,
  Card,
  CardBody,
} from "reactstrap"
import DeleteModal from "../../../../components/Common/DeleteModal"
import {
  deletePurchase,
  getPurchases,
  updatePurchase,
} from "../../../../store/purchases/actions"
import ConfirmModal from "../../../../components/Common/confirmModal"

function ClientsPurchases() {
  let params = useParams()
  let location = useLocation()
  const [modal, setModal] = useState(false)
  const [isEdit, setIsEdit] = useState(false)

  const [ceremony_pack, setCeremony] = useState([])
  const [offset, setOffset] = useState(0)
  const [page_size, setPageSize] = useState(10)

  const dispatch = useDispatch()
  const purchases = (
    useSelector(state => state.purchases.data) ?? []
  )?.reverse()
  const total_page = useSelector(state => state.purchases.total_page)
  const loading = useSelector(state => state.purchases.loading)

  useEffect(() => {
    dispatch(getPurchases({ offset, page_size }))
  }, [dispatch, offset, page_size])

  useEffect(() => {
    if (!isEmpty(purchases)) {
      setIsEdit(false)
    }
  }, [purchases])

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false)
      setCeremony(null)
    } else {
      setModal(true)
    }
  }, [modal])

  //delete ceremony_pack
  const [deleteModal, setDeleteModal] = useState(false)
  const [confirmModal, setconfirmModal] = useState(false)
  const [paidStatus, setpaidStatus] = useState({
    id: 0,
    status: 0,
  })

  const onClickDelete = ceremony_pack => {
    setCeremony(ceremony_pack)
    setDeleteModal(true)
  }

  const handleDeleteUser = () => {
    if (ceremony_pack.id) {
      dispatch(deletePurchase(ceremony_pack))
      // setDeleteModal(false)
    }
  }
  useEffect(() => {
    if (!loading) {
      setDeleteModal(false)
      setModal(false)
    }
  }, [loading])
  const handleUserClicks = () => {
    setIsEdit(false)
    toggle()
  }
  const UpdatePaidStatus = () => {
    dispatch(
      updatePurchase({
        activation: 1,
        is_paid: paidStatus.status,
        id: paidStatus.id,
      })
    )
    setconfirmModal(false)
  }

  const ChangePaidStatus = ({ id, status }) => {
    setpaidStatus({
      id,
      status,
    })
    setconfirmModal(true)
  }

  const columns = useMemo(
    () => [
      // {
      //   Header: "Id",
      //   accessor: "checkbox",
      //   disableFilters: true,
      //   filterable: false,
      //   Cell: cellProps => {
      //     return <input type="checkbox" className="selection-input-4" />
      //   },
      // },
      {
        Header: "Client",
        accessor: "client_name",
        filterable: true,
        Cell: cellProps => {
          return <Event_Description {...cellProps} />
        },
      },
      {
        Header: "Vendor",
        accessor: "vendor_name",
        filterable: true,
        Cell: cellProps => {
          return <Vendor_name {...cellProps} cellp={cellProps} />
        },
      },
      {
        Header: "date",
        accessor: "created_at",
        filterable: true,

        Cell: cellProps => {
          return <Package {...cellProps} />
        },
      },

      {
        Header: "Paid date",
        accessor: "paid_date",
        filterable: true,

        Cell: cellProps => {
          return <PaidDate {...cellProps} />
        },
      },
      {
        Header: "Amount",
        accessor: "discount_amount",
        filterable: true,

        Cell: cellProps => {
          return <PurchaseAmount {...cellProps} />
        },
      },
      {
        Header: "Paid",
        accessor: "is_paid",
        filterable: true,
        disableFilters: true,

        Cell: cellProps => (
          <div className="form-check form-switch form-switch-lg">
            {cellProps.value == 1 ? (
              <input
                disabled={loading}
                onClick={e => {
                  ChangePaidStatus({
                    id: cellProps.row.original.id,
                    status: 0,
                  })
                }}
                type="checkbox"
                className="form-check-input"
                id="customSwitchsizelg"
                checked={true}
              />
            ) : (
              <input
                disabled={loading}
                onClick={e => {
                  ChangePaidStatus({ id: cellProps.row.original.id, status: 1 })
                }}
                type="checkbox"
                className="form-check-input"
                id="customSwitchsizelg"
                checked={false}
              />
            )}
          </div>
        ),
      },
      {
        Header: "Action",
        accessor: "action",
        disableFilters: true,
        Cell: cellProps => {
          return cellProps.row.original.is_deleted === 1 ||
            cellProps.row.original.is_canceled == 1 ? (
            <div />
          ) : (
            <div className="d-flex gap-3 users">
              <ul className="list-inline font-size-20 contact-links mb-0">
                <li className="list-inline-item">
                  <Link
                    to="#"
                    className="text-danger"
                    onClick={() => {
                      const purchases = cellProps.row.original
                      onClickDelete(purchases)
                    }}
                  >
                    <i
                      className="uil uil-trash-alt font-size-18"
                      id="deletetooltip"
                    />
                    <UncontrolledTooltip placement="top" target="deletetooltip">
                      Delete
                    </UncontrolledTooltip>
                  </Link>
                </li>
              </ul>
            </div>
          )
        },
      },
    ],
    [loading]
  )

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteUser}
        onCloseClick={() => setDeleteModal(false)}
        loading={loading}
      />
      <ConfirmModal
        show={confirmModal}
        onConfirmClick={UpdatePaidStatus}
        onCloseClick={() => setconfirmModal(false)}
        loading={loading}
      />
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="MENU" breadcrumbItem={" purchases"} />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <TableContainer
                    columns={columns}
                    data={purchases}
                    isGlobalFilter={true}
                    isAddUsers={true}
                    isAddTableWithoutBorderStrap={true}
                    handleUserClicks={handleUserClicks}
                    setPage={setOffset}
                    page_number={offset}
                    total_pages={total_page}
                    setPageSize={setPageSize}
                    page_size={page_size}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Modal isOpen={modal} toggle={toggle}>
            <ModalHeader toggle={toggle} tag="h4">
              {!!isEdit ? "Edit User" : "Add Users"}
            </ModalHeader>
            <ModalBody></ModalBody>
          </Modal>
        </div>
      </div>
    </React.Fragment>
  )
}
ClientsPurchases.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
}

export default ClientsPurchases
